import React from 'react'

/**
 * Secondary left rail schema by `activeKey` from primary nav (`getPrimaryKeyFromPath`).
 *
 * Section `type` values rendered in `SecondaryLeftNavigation/index.jsx`:
 * - `boardsPreview` | `boardsLanding` — BoardsSection; data: navigationData adapters
 * - `appsPreview` | `appsLanding` — AppsSection; data: `topApps` / `allApps` on section ctx
 * - `newChatAction` — ActionButtonRow
 * - `homeThreadsRail` — Threads header, New Chat, and thread list below Boards (home)
 * - `searchRow` — SearchRow (home)
 * - `divider` | `placeholder` — layout / fallback
 */

export const SECONDARY_VIEW_KEYS = {
  HOME_MAIN: 'home-main',
  HOME_BOARDS_ALL: 'home-boards-all',
}
